import * as React from "react";
import { CICOContainer } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/CICOContainer";
import { ClientLogs } from "source/app/presentation/MainPanel/DevTools/ClientLogs";
import { ClientErrorScreenDevelopmentControl } from "source/app/presentation/MainPanel/DevTools/ClientErrorScreenDevelopmentControl";
import { ClientUpdateNoticeDevelopmentControl } from "source/app/presentation/MainPanel/DevTools/ClientUpdateNoticeDevelopmentControl";
import { FilePasteTool } from "source/app/presentation/MainPanel/DevTools/FilePaste/FilePasteTool";
import { QuickJournalClock } from "source/app/presentation/MainPanel/DevTools/QuickJournalClock";
import { Phrasing } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Phrasing/Phrasing";
import { DailySpend } from "./DailySpend";
import { DistancingCalculator } from "./DistancingCalculator";
import { Prayer } from "./Prayer/Prayer";
import { PsycheRadar } from "./PsycheRadar/PsycheRadar";
import { SurvivalGuide } from "./SurvivalGuide";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StateProgressChart } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/StateProgressChart";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { Texturizer } from "source/app/presentation/MainPanel/DevTools/Texturizer/Texturizer";
import { YoutubeDownloader } from "source/app/presentation/MainPanel/DevTools/Youtube/Download/YoutubeDownloader";
import { YoutubeSearch } from "source/app/presentation/MainPanel/DevTools/Youtube/Search/YoutubeSearch";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import { BookOfMindSpeechCacheStats } from "./BookOfMindSpeechCacheStats";
import { ChromaFlare } from "./ChromaFlare/ChromaFlare";
import { TreeSunlight } from "./TreeSunlight/TreeSunlight";

export class UnderDevelopment extends React.Component<{}, {}> {
    constructor(props: {}) {
        super(props);
    }

    render() {
        return (
            <div
                className={StyleClassAuto({
                    display: `flex`,
                    flexDirection: `column`,
                    gap: `8px`,
                    paddingTop: `10px`,
                })}
            >
                <ChevronPanel
                    id="UnderDevelopment_ClientUpdate"
                    label="Client flags"
                    icon={ERPGIcon.cycle}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <ClientUpdateNoticeDevelopmentControl />
                    <ClientErrorScreenDevelopmentControl />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_PsycheRadar"
                    label="Psyche radar"
                    icon={ERPGIcon["radar-dish"]}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <PsycheRadar />
                </ChevronPanel>
                <ClientLogs />
                <BookOfMindSpeechCacheStats />
                <ChevronPanel
                    id="UnderDevelopment_ChromaFlare"
                    label="Chroma flare"
                    icon={ERPGIcon.sun}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({ textAlign: "center" })}
                >
                    <ChromaFlare />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_TreeSunlight"
                    label="Sunlight through trees"
                    icon={ERPGIcon.sun}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({ textAlign: "center" })}
                >
                    <TreeSunlight />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_QuickJournalClock"
                    label="QuickJournal time"
                    icon={ERPGIcon.clockwork}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <QuickJournalClock />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_YoutubeSearch"
                    label="YouTube search"
                    icon={ERPGIcon.telescope}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <YoutubeSearch />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_YoutubeDownloader"
                    label="YouTube downloader"
                    icon={ERPGIcon.load}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <YoutubeDownloader />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_Texturizer"
                    label="Texturizer"
                    icon={ERPGIcon.spray}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <Texturizer />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_FilePaste"
                    label="Paste file"
                    icon={ERPGIcon["surveillance-camera"]}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <FilePasteTool />
                </ChevronPanel>
                <StateProgressChart />
                <ChevronPanel
                    id="UnderDevelopment_TestLink"
                    label="Test link"
                    icon={ERPGIcon.chain}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <IconWithText
                        whenClicked={() => {
                        }}
                        iconSuffix={EGlyphicon.wrench}
                        displayAsBlock
                    >
                        Test link
                    </IconWithText>
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_CICO"
                    label="CICO"
                    icon={ERPGIcon["flame-symbol"]}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <CICOContainer />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_Phrasing"
                    label="Phrasing"
                    icon={ERPGIcon["speech-bubble"]}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <Phrasing />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_Prayer"
                    label="Prayer"
                    icon={ERPGIcon.candle}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <Prayer />
                </ChevronPanel>
                <SurvivalGuide />
                <ChevronPanel
                    id="UnderDevelopment_DistancingCalculator"
                    label="Distancing Calculator"
                    icon={ERPGIcon.compass}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <DistancingCalculator />
                </ChevronPanel>
                <ChevronPanel
                    id="UnderDevelopment_DailySpend"
                    label="Daily Spend"
                    icon={ERPGIcon["gold-bar"]}
                    dynamicOpacity={false}
                    withClasses={StyleClassAuto({
                        textAlign: `center`,
                    })}
                >
                    <DailySpend />
                </ChevronPanel>
            </div>
        );
    }
}
